import {
  FaFileAlt,
  FaFilePdf,
  FaFileImage,
  FaFileWord,
  FaFileExcel,
  FaFile,
} from "react-icons/fa";
import useAxiosPrivate from "./useAxiosPrivate";

export const useFiles = () => {
  const axiosPrivate = useAxiosPrivate();
  const fileIcon = {
    fontSize: "24px",
    color: "#666",
    flexShrink: "0",
  };

  // Helper function to get file icon based on file type
  const getFileIcon = (fileType, fileName) => {
    if (fileType?.includes("pdf")) {
      return <FaFilePdf className={fileIcon} />;
    }
    if (fileType?.includes("image")) {
      return <FaFileImage className={fileIcon} />;
    }
    if (fileType?.includes("word") || fileName?.match(/\.(doc|docx)$/i)) {
      return <FaFileWord className={fileIcon} />;
    }
    if (fileType?.includes("excel") || fileName?.match(/\.(xls|xlsx)$/i)) {
      return <FaFileExcel className={fileIcon} />;
    }
    if (fileType?.includes("text") || fileName?.match(/\.(txt)$/i)) {
      return <FaFileAlt className={fileIcon} />;
    }
    return <FaFile className={fileIcon} />;
  };

  // Format file size
  const formatFileSize = (bytes) => {
    if (!bytes) return '';
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  };

  // Helper function for the download logic
  const triggerDownload = (blob, fileName) => {
    const blobUrl = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = blobUrl;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    
    // Cleanup with delay
    setTimeout(() => {
      document.body.removeChild(a);
      URL.revokeObjectURL(blobUrl);
    }, 100);
  };

  // Download file handler - fetch and create blob
  const handleDownload = async (url, fileName) => {
    try {
      // Use axiosPrivate for backend files
      const response = await axiosPrivate.get(url, {
        responseType: 'blob', // Important for file downloads
      });

      // Get the blob from axios response
      const blob = new Blob([response.data], { 
        type: response.headers['content-type'] || 'application/octet-stream'
      });

      triggerDownload(blob, fileName);
    } catch (err) {
      console.error("Download failed:", err);
      // Fallback: open in new tab
      window.open(url, "_blank");
    }
  };

  return {
    getFileIcon,
    formatFileSize,
    handleDownload,
  };
};
